import { computed, onBeforeUnmount, ref } from 'vue';
import LiveCallsAPI from 'dashboard/api/smarttec/liveCalls';

const POLLING_INTERVAL = 5000;

export const useLiveCalls = () => {
  const liveCalls = ref([]);
  const isLoadingLiveCalls = ref(false);
  const liveCallsError = ref(null);

  let pollingTimer = null;
  let requestInProgress = false;

  const callsByAgentId = computed(() => {
    return liveCalls.value.reduce((result, call) => {
      const agentId = call?.agent_id;

      if (agentId !== null && agentId !== undefined) {
        result[String(agentId)] = call;
      }

      return result;
    }, {});
  });

  const fetchLiveCalls = async () => {
    if (requestInProgress) return;

    requestInProgress = true;
    isLoadingLiveCalls.value = true;
    liveCallsError.value = null;

    console.log('[SMARTTEC] Consultando llamadas activas');

    try {
      const response = await LiveCallsAPI.get();
      const payload = response?.data?.payload;

      liveCalls.value = Array.isArray(payload) ? payload : [];

      console.log(
        '[SMARTTEC] Respuesta live_calls:',
        response.status,
        liveCalls.value
      );
    } catch (error) {
      liveCallsError.value = error;
      liveCalls.value = [];

      console.error(
        '[SMARTTEC] Error live_calls:',
        error?.response?.status,
        error?.response?.data || error?.message || error
      );
    } finally {
      requestInProgress = false;
      isLoadingLiveCalls.value = false;
    }
  };

  const getAgentCall = agentId => {
    return callsByAgentId.value[String(agentId)] || null;
  };

  const stopLiveCallsMonitoring = () => {
    if (pollingTimer !== null) {
      window.clearInterval(pollingTimer);
      pollingTimer = null;
    }
  };

  const startLiveCallsMonitoring = () => {
    console.log('[SMARTTEC] Monitoreo de llamadas iniciado');

    stopLiveCallsMonitoring();
    fetchLiveCalls();

    pollingTimer = window.setInterval(
      fetchLiveCalls,
      POLLING_INTERVAL
    );
  };

  onBeforeUnmount(stopLiveCallsMonitoring);

  return {
    liveCalls,
    isLoadingLiveCalls,
    liveCallsError,
    fetchLiveCalls,
    getAgentCall,
    startLiveCallsMonitoring,
    stopLiveCallsMonitoring,
  };
};
